export const TAGLINE = "Protico";
export const WEBSITE_URL = "https://example.com";
export const WEBSITE_NAME = "Protico";
export const LOCAL_STORAGE_KEY = "Protico-Dapp";

export function truncate(str: string, n: number, useWordBoundary: boolean) {
  if ((str && str.length <= n) || !str) {
    return str;
  }

  const subString = str.substr(0, n - 1); // the original check
  return (
    (useWordBoundary
      ? subString.substr(0, subString.lastIndexOf(" "))
      : subString) + "&hellip;"
  );
}

export function titlefy(slug: string) {
  var words = slug.split("-");

  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }

  return words.join(" ");
}

export enum LocalStorageKeys {
  APP_VISIT_COUNT = "APP_VISIT_COUNT", // Just used for pwa checking
  PWA_DISMISS_DATE  = "PWA_DISMISS_DATE",
  METAMASK_ADDRESS = "METAMASK_ADDRESS",
  DOMAINS = "DOMAINS",
  CURRENT_TAB = "CURRENT_TAB",
  DAYS_OF_USE = "DAYS_OF_USE",
  LAST_LOGIN_DATE = "LAST_LOGIN_DATE",
  VOUCHER_LIST = "VOUCHER_LIST",
  IF_HYPERLINK = "IF_HYPERLINK",
  IF_FIRSTMSGSENT = "IF_FIRSTMSGSENT",
  IF_FIRSTNFTSENT = "IF_FIRSTNFTSENT",
  IF_CHATLV1 = "IF_CHATLV1", // Check if the user has joined a room with 1 ppl
  IF_CHATLV2 = "IF_CHATLV2", // Check if the user has joined a room with 5 ppl
  IF_CHATLV3 = "IF_CHATLV3", // Check if the user has joined a room with 10 ppl
  IF_CHATLV4 = "IF_CHATLV4", // Check if the user has joined a room with 20 ppl
  IF_CHATLV5 = "IF_CHATLV5", // Check if the user has joined a room with 50 ppl
  PRIVATE_KEY = "PRIVATE_KEY",
  IS_INVITED = "IS_INVITED",
  USER_ID = "USER_ID",
  VOUCHER_CODE = "VOUCHER_CODE", // The invitation code that the user used to join protico
  INVITED_BY = "INVITED_BY",
  ENS_REQUESTED = "ENS_REQUESTED", // Whether has asked user to use bundled ENS as name. Workaround for first registry
  ASSET_LIST = "ASSET_LIST", // To save loaded asset list.
  ASSET_LAST_UPDATE_TIME = "ASSET_LAST_UPDATE_TIME",
  IS_IFRAME_ALLOWED = "IS_IFRAME_ALLOWED", // Whether user allow iframe to be added on every webpage
  WALLETCONNECT_DEEPLINK_CHOICE = "WALLETCONNECT_DEEPLINK_CHOICE", // we need to clear local storage for walletconnect v1 deeplink
}
